import api from '@cannect/services/api'
import { TResponseStandard } from '@cannect/services/types'
import type { TSearchWebhookParams, TWebhookResponse } from './types'

export const sendSearchWebhook = async (params: TSearchWebhookParams) => {
  return api.post<TResponseStandard<TWebhookResponse, 'webhook'>>('/teams-search', params).then(({ data }) => data)
}
